import React, { useState } from 'react';
import { Modal, Card } from "react-bootstrap";
import { Input, Select, setOptions } from '@mobiscroll/react5';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addClinicBankDetails } from './api';
import Loader from "src/components/Dashboard/common/Loader";

setOptions({ theme: 'ios', themeVariant: 'light' });

const initialValues = {
    bankAccountNumber: "",
    ifscCode: "",
    accountType: "savings",
    businessType: "proprietorship",
    beneficiaryName: ""
};

const validationSchema = Yup.object({
    bankAccountNumber: Yup.string().required('Required').matches(/^\d+$/, 'Digits only'),
    ifscCode: Yup.string().required('Required').length(11, 'Must be 11 characters'),
    accountType: Yup.string().required(),
    businessType: Yup.string().required(),
    beneficiaryName: Yup.string().nullable(),
});

const accountTypeData = [
    { text: 'Savings', value: 'savings' },
    { text: 'Current', value: 'current' }
];

const businessTypeData = [
    { text: 'Proprietorship', value: 'proprietorship' },
    { text: 'Partnership', value: 'partnership' },
    { text: 'Private Limited', value: 'private_limited' },
    { text: 'Public Limited', value: 'public_limited' },
    { text: 'LLP', value: 'llp' },
    { text: 'NGO', value: 'ngo' },
    { text: 'Trust', value: 'trust' },
    { text: 'Society', value: 'society' },
    { text: 'HUF', value: 'huf' },
    { text: 'Not Yet Registered', value: 'not_yet_registered' }
];

const BankDetails = ({ show, setShow, clinicId }) => {
    const [loader, setLoader] = useState(false);

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            setLoader(true);
            try {
                const response = await addClinicBankDetails({ ...values, clinicId });
                if (response) {
                    setShow(false);
                }
            } catch (err) {
                console.error("Error adding bank details:", err);
            } finally {
                setLoader(false);
            }
        },
    });

    return (
        <Modal show={show} onHide={() => setShow(false)} centered size="lg" backdrop="static">
            <Loader show={loader} />
            <Card className="docg-card docg-patient-form-wrapper">
                <Card.Header className="customCardHeader">
                    <Card.Title className="mb-0">Add Bank Details</Card.Title>
                </Card.Header>
                <Card.Body>
                    <form onSubmit={formik.handleSubmit} className='p-4'>
                        <p style={{ color: '#6C5B7B', textAlign: 'center' }}>
                            <i>(Please provide bank details to enable online payments)</i>
                        </p>

                        <div className="row">
                            <div className="col-12">
                                <Input
                                    label="Beneficiary Name"
                                    placeholder="Doctor / Clinic Name"
                                    labelStyle="floating"
                                    inputStyle="underline"
                                    {...formik.getFieldProps('beneficiaryName')}
                                />
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className='col-6'>
                                <Input
                                    label="Account Number*"
                                    labelStyle="floating"
                                    inputStyle="underline"
                                    error={formik.touched.bankAccountNumber && !!formik.errors.bankAccountNumber}
                                    errorMessage={formik.errors.bankAccountNumber}
                                    {...formik.getFieldProps('bankAccountNumber')}
                                />
                            </div>
                            <div className="col-6">
                                <Input
                                    label="IFSC Code*"
                                    labelStyle="floating"
                                    inputStyle="underline"
                                    error={formik.touched.ifscCode && !!formik.errors.ifscCode}
                                    errorMessage={formik.errors.ifscCode}
                                    {...formik.getFieldProps('ifscCode')}
                                />
                            </div>
                        </div>

                        <div className="row my-4">
                            <div className="col-md-6">
                                <Select
                                    label="Account Type*"
                                    labelStyle="floating"
                                    inputStyle="underline"
                                    data={accountTypeData}
                                    value={formik.values.accountType}
                                    onChange={(ev) => formik.setFieldValue('accountType', ev.value)}
                                />
                            </div>
                            <div className="col-md-6">
                                <Select
                                    label="Business Type*"
                                    labelStyle="floating"
                                    data={businessTypeData}
                                    value={formik.values.businessType}
                                    onChange={(ev) => formik.setFieldValue('businessType', ev.value)}
                                />
                            </div>
                        </div>

                        <div className="row d-flex justify-content-center gap-4" style={{ marginTop: '50px' }}>
                            <button type="button" onClick={() => setShow(false)} className='docg-outline-btn'>Cancel</button>
                            <button type="submit" disabled={formik.isSubmitting} className='docg-save-btn'>
                                {formik.isSubmitting ? 'Saving...' : 'Submit Details'}
                            </button>
                        </div>
                    </form>
                </Card.Body>
            </Card>
        </Modal>
    );
};

export default BankDetails;